export type PromptTargetType = 'data-extraction' | 'summarize'

export type TargetPromptAiModel = 'default' | 'light' | 'standard' | 'extended'

export type ExtractionTarget =
  | 'DE:Stakeholders.V1.CreateClient'
  | 'DE:Stakeholders.V1.CreateVendor'
  | 'DE:Stakeholders.V1.CreateOtherParty'
  | 'DE:Stakeholders.V1.CreateMultipleContacts'
  | 'DE:Stakeholders.V1.CreateContact'

export type PromptTarget =
  | 'DE:Stakeholders.CreateClient'
  | 'DE:Stakeholders.CreateVendor'
  | 'DE:Stakeholders.CreateOtherParty'
  | 'DE:Stakeholders.CreateContact'
  | 'DE:Stakeholders.CreateMultipleContacts'

export function mapExtractionTargetToPromptTarget(
  extractionTarget: ExtractionTarget
): PromptTarget {
  switch (extractionTarget) {
    case 'DE:Stakeholders.V1.CreateClient':
      return 'DE:Stakeholders.CreateClient'
    case 'DE:Stakeholders.V1.CreateVendor':
      return 'DE:Stakeholders.CreateVendor'
    case 'DE:Stakeholders.V1.CreateOtherParty':
      return 'DE:Stakeholders.CreateOtherParty'
    case 'DE:Stakeholders.V1.CreateMultipleContacts':
      return 'DE:Stakeholders.CreateMultipleContacts'
    case 'DE:Stakeholders.V1.CreateContact':
      return 'DE:Stakeholders.CreateContact'
    default:
      throw new Error(`Invalid extraction target: ${extractionTarget}`)
  }
}

export function getExtractionTargetFromPromptTarget(
  promptTarget: PromptTarget
): ExtractionTarget {
  switch (promptTarget) {
    case 'DE:Stakeholders.CreateClient':
      return 'DE:Stakeholders.V1.CreateClient'
    case 'DE:Stakeholders.CreateVendor':
      return 'DE:Stakeholders.V1.CreateVendor'
    case 'DE:Stakeholders.CreateOtherParty':
      return 'DE:Stakeholders.V1.CreateOtherParty'
    case 'DE:Stakeholders.CreateMultipleContacts':
      return 'DE:Stakeholders.V1.CreateMultipleContacts'
    case 'DE:Stakeholders.CreateContact':
      return 'DE:Stakeholders.V1.CreateContact'
    default:
      throw new Error(`Invalid prompt target: ${promptTarget}`)
  }
}

export type AiPromptAsset = {
  /** The ID of the prompt asset. */
  id: string
  /** The type of the prompt asset. */
  promptType: PromptTargetType
  /** The target ID of the prompt asset. */
  promptTargetId: PromptTarget
  /** The display name of the prompt asset. */
  displayName: string
  /** The base instruction of the prompt asset. */
  shortDescription: string
  /** The target AI model of the prompt asset. */
  targetAiModel: TargetPromptAiModel
  /**The default model of the prompt asset.*/
  defaultModel: TargetPromptAiModel
  /** The prompt text of the prompt asset. */
  promptText: string
  /** Whether the prompt asset is the default prompt for the target. */
  isDefault: boolean
}
